import { useEffect, useState } from "react";
import { Form } from "../../common/Form";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { CommonDialog } from "../../common/CommonDialog";
import { jwordAlignmentOptions,jwordLineSpaceOptions,jwordSpecialIndentOptions} from "./jword-config";
import { useTranslation } from "react-i18next";

export function ParaDialog({paraProps,visible,onOK,onCancel,units})
{    
    const {t} = useTranslation();
    const [paraInfo,setParaInfo]=useState();
    const [spaceValDisabled,setSpaceValDisabled]=useState(false);
    const [indentValDisabled,setIndentValDisabled]=useState(false);

    const onChange=(formData)=>{        
        setParaInfo(formData);
        setSpaceValDisabled(formData.lineSpaceMode === 'single' || formData.lineSpaceMode === 'double');
        setIndentValDisabled(formData.specialIndent === 'none');
    };
    const _onCancel=()=>{
        onCancel();
    };
    const _onOK=()=>{
        onOK(paraInfo);
    };
    const alignOptions=()=>{
        return jwordAlignmentOptions.map((opt)=>{return {label:t('Editor.align.'+opt),value:opt}});
    }
    const specialIndentOptions=()=>{
        return jwordSpecialIndentOptions.map((opt)=>{return {label:t('Editor.specialIndent.'+opt),value:opt}});
    }
    const lineSpaceOptions=()=>{
        return jwordLineSpaceOptions.map((opt)=>{return {label:t('Editor.lineSpace.'+opt),value:opt}});
    }
    useEffect(()=>{
        //console.log("paraProps:"+JSON.stringify(paraInfo));
        setParaInfo({...paraProps});
    },[paraProps,units]);
    return(
        <>
        <CommonDialog header={t('Editor.Paragraph_Settings')} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div className="p-2" style={{maxWidth:'400px'}}>
            <Form id="formatPara" formData={paraInfo} columns="1" onChange={onChange}
                fields={[
                    {id:"align",ftype:"dropdown",field:"align",label:t('Editor.Alignment'),options:alignOptions()}
                ]}>
            </Form>	
            <Form id="formatParaIndent" formData={paraInfo} columns="2" onChange={onChange}
                fields={[
                    {id:"leftIndent",ftype:"number",field:"leftIndent",label:t('Editor.Left_Indent')+" ("+units+")"},
                    {id:"specialIndent",ftype:"dropdown",field:"specialIndent",label:t('Editor.Special_Indent'),options:specialIndentOptions()},
                    {id:"rightIndent",ftype:"number",field:"rightIndent",label:t('Editor.Right_Indent')+" ("+units+")"},
                    {id:"indentVal",ftype:"number",field:"indentVal",label:t('Editor.Indent_Value')+" ("+units+")", disabled:{indentValDisabled}}
            ]}>
            </Form>	
            <Form id="formatParaSpace" formData={paraInfo} columns="2" onChange={onChange}
                fields={[
                    {id:"spaceBefore",ftype:"number",field:"spaceBefore",label:t('Editor.Space_Before_(pt)')},
                    {id:"lineSpaceMode",ftype:"dropdown",field:"lineSpaceMode",label:t('Editor.Line_Space'),options:lineSpaceOptions()},
                    {id:"spaceAfter",ftype:"number",field:"spaceAfter",label:t('Editor.Space_After_(pt)')},
                    {id:"lineSpacing",ftype:"number",field:"lineSpacing",label:t('Editor.Space_Value'), disabled:{spaceValDisabled}}
            ]}>
            </Form>	
            <Form id="formatParaCheck" formData={paraInfo} columns="1" onChange={onChange}
                fields={[
                    {id:"preventSingle",ftype:"checkbox",field:"preventSingle",label:t('Editor.Prevent_single_lines')},
                    {id:"preventSplit",ftype:"checkbox",field:"preventSplit",label:t('Editor.Prevent_splitting')}
                ]}>
            </Form>	
            </div>
        </CommonDialog>
        </>
    );
}